/** router commons function and variables. */
function regionTree(region, list) {
    return {
        searchable: true,
        selectable: true,
        selectionType: 'leaf',
        selectionStyle: 'single',
        customClass: 'hidden-parents-checkbox',
        label(i) { return i.fullname || i.name; },
        id(i) { return i.id },
        hasChildren(i) { return list ? false : !i.leaf },
        url(i) {
            return `/p/lbs/district/${i ? i.id : (region || 0)}`;
        }
    };
}

function independentRegionTree(region, list) {
    return {
        searchable: true,
        label(i) { return `${i.fullname || i.name}(${i.id})`; },
        id(i) { return i.id },
        hasChildren(i) { return list ? false : !i.leaf },
        url(i) {
            return `/p/lbs/district/${i ? i.id : (region || 0)}`;
        }
    };
}

function catalogTree(tid) {
    return {
        label(i) { return i.domainId ? i.label : i.name },
        id(i) { return i.domainId ? `${i.domainId}_${i.id}` : i.id; },
        hasChildren(i) { return i.catalogCount && i.catalogCount > 0; },
        url(i) {
            if (i) {
                return `/home/my/tenant/catalog/list/${i.domainId || i.id}/${i.domainId ? i.id : 0}?_tid=${tid || 0}`;
            } else {
                return `/home/my/tenant/domain/list?_tid=${tid || 0}`;
            }
        }
    };
}

function orgTree(disableActiveFirst, eleaf) {
    return {
        title: '组织机构',
        disableActiveFirst: disableActiveFirst,
        searchable: true,
        label(i) { return i.name; },
        id(i) { return i.id },
        hasChildren(i) { return i.orgCount > 0 },
        url(i) {
            let self = this;
            return `/home/my/tenant/org/children?_org=${i ? i.id : (self.$store.state.account.orgId || 0)}&_eleaf=${eleaf || false}`;
        }
    }
}

export {
    regionTree, independentRegionTree, catalogTree, orgTree
};

